// 菜单 顶栏
export default [{
    path: '/index',
    title: '首页'
  },
  {
    path: '/cmailbox',
    title: '主席信箱',
    active: 0,
    menu: [{
      title: '主席信箱',
      enTitle: "Chairman's mailbox",
      code: 'letter',
      type: 'richText',
    }, {
      title: '公开的提问',
      enTitle: "Open questions",
      code: 'textList',
      type: 'list',
    }, {
      title: '我的提问',
      enTitle: "My question",
      code: 'textList',
      type: 'list',
    }, {
      title: '未回复列表',
      enTitle: "No reply list",
      code: 'textList',
      type: 'list',
    }]
  },
  {
    path: '/tradeinfo',
    title: '工会信息',
    active: 0,
    menu: [{
      title: '工会信息',
      enTitle: "Trade union information",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '政策法规',
      enTitle: "Policies and regulations",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '组织架构',
      enTitle: "organizational structure",
      code: 'pdf',
      type: 'richText',
    }, {
      title: '工会表格',
      enTitle: "Trade union form",
      code: 'pdflist',
      type: 'list',
    }, {
      title: '会员手册',
      enTitle: "Member Handbook",
      code: 'pdfOpera',
      type: 'richText',
    }]
  },
  {
    path: '/tradeactivity',
    title: '工会活动',
    active: 0,
    menu: [{
      title: '工会活动',
      enTitle: "Trade union activities",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '工会集锦',
      enTitle: "Trade union collection",
      code: 'activitylist',
      type: 'list',
    }, 
    {
      title: '活动分享',
      enTitle: "ACTIVITY SHARING",
      code: 'activitylist',
      type: 'list',
    }, 
    {
      title: '家庭日',
      enTitle: "FAMILY DAY",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '篮球赛',
      enTitle: "BASKETBALL MATCH",
      code: 'activitylist',
      type: 'list',
    }]
  },
  {
    path: '/unionbenefits',
    title: '工会福利',
    active: 0,
    menu: [{
      title: '生日慰问',
      enTitle: "Birthday greetings",
      code: 'rule',
      type: 'richText',
    }, 
    // {
    //   title: '电影观摩',
    //   enTitle: "Film viewing",
    //   code: 'rule',
    //   type: 'richText',
    // }, 
    {
      title: '高温慰问',
      enTitle: "High temperature sympathy",
      code: 'rule',
      type: 'richText',
    }, {
      title: '节日慰问',
      enTitle: "Holiday greetings",
      code: 'rule',
      type: 'richText',
    }, {
      title: '职代会纪念品',
      enTitle: "Souvenirs of workers' Congress",
      code: 'rule',
      type: 'richText',
    }, {
      title: '儿童节慰问',
      enTitle: "Children's Day condolences",
      code: 'rule',
      type: 'richText',
    }, {
      title: '妇女节慰问',
      enTitle: "Condolences on women's Day",
      code: 'rule',
      type: 'richText',
    }, {
      title: '退休福利',
      enTitle: "Retirement benefits",
      code: 'rule',
      type: 'richText',
    }, {
      title: '生育慰问',
      enTitle: "Retirement benefits",
      code: 'rule',
      type: 'richText',
    }, {
      title: '结婚慰问',
      enTitle: "Marriage consolation",
      code: 'rule',
      type: 'richText',
    }, {
      title: '病假慰问',
      enTitle: "Sick leave consolation",
      code: 'rule',
      type: 'richText',
    }]
  },
  {
    path: '/unionsubsidy',
    title: '工会补助',
    active: 0,
    menu: [{
      title: '上级工会临时帮困',
      enTitle: "The trade union at a higher level provides temporary assistance",
      code: 'rule',
      type: 'richText',
    }, {
      title: '会员七类特种病补助',
      enTitle: "Subsidies for seven special diseases of members",
      code: 'rule',
      type: 'richText',
    }, {
      title: '会员直系亲属重大疾病补助',
      enTitle: "Major disease allowance for immediate family members",
      code: 'rule',
      type: 'richText',
    }, {
      title: '工会会员伤残帮困补助',
      enTitle: "Subsidies for disabled trade union members",
      code: 'rule',
      type: 'richText',
    }, {
      title: '工会会员因公去世帮困补助',
      enTitle: "Subsidy for helping the poor when a union member dies on business",
      code: 'rule',
      type: 'richText',
    }, {
      title: '会员重病关爱保障',
      enTitle: "Care and protection for serious illness of members",
      code: 'rule',
      type: 'richText',
    }, {
      title: '工会会员非因公去世帮困补助',
      enTitle: "Subsidy for helping the poor when a union member dies on non business",
      code: 'rule',
      type: 'richText',
    }, {
      title: '“爱助”计划帮扶金',
      enTitle: '"Love help" program Assistance Fund',
      code: 'rule',
      type: 'richText',
    }]
  },
  {
    path: '/deputy',
    title: '身边的代表',
    active: 0,
    menu: [{
      title: '代表名单',
      enTitle: "List of Representatives",
      code: 'roster',
      type: 'list',
    }, {
      title: '职代会代表专线',
      enTitle: "Special line for representatives of workers' Congress",
      code: 'line',
      type: 'list',
    }, {
      title: '工会发布列表',
      enTitle: "Trade union release list",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '代表职责',
      enTitle: "Responsibilities of Representative",
      code: 'duty',
      type: 'richText',
    }, {
      title: '我的发布',
      enTitle: "My release",
      code: 'comment',
      type: 'list',
    }, {
      title: '我的评论',
      enTitle: "My comments",
      code: 'comment',
      type: 'list',
    }]
  },
  {
    path: '/myunion',
    title: '我的工会',
    active: 0,
    menu: [{
      title: '我的消息',
      enTitle: "My message",
      code: 'message',
      type: 'list',
    },  {
      title: '入会申请',
      enTitle: "Membership Application",
      code: 'info',
      type: 'form',
    },{
      title: '我的信息',
      enTitle: "My information",
      code: 'info',
      type: 'form',
    }, {
      title: '我的积分',
      enTitle: "My points",
      code: 'points',
      type: 'list',
    }, {
      title: '我的福利',
      enTitle: "My welfare",
      code: 'welfare',
      type: 'list',
    }, {
      title: '我的活动',
      enTitle: "My activities",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '我的代金券',
      enTitle: "My voucher",
      code: 'points',
      type: 'list',
    }, {
      title: '我的电子卡',
      enTitle: "My electronic card",
      code: 'activitylist',
      type: 'list',
    }, {
      title: '我的申请',
      enTitle: "My application",
      code: 'textList',
      type: 'list',
    }, {
      title: '我的兑换',
      enTitle: "My exchange",
      code: 'points',
      type: 'list',
    }, {
      title: '操作手册',
      enTitle: "Operation manual",
      code: 'pdf',
      type: 'richText'
    }]
  },
  {
    path: '/task',
    title: '我的任务',
    active: 0,
    menu: [{
      title: '待处理',
      enTitle: "task is pending",
      code: 'textList',
      type: 'list',
    }, {
      title: '已处理',
      enTitle: "task has been processed",
      code: 'textList',
      type: 'list',
    }]
  },
  // {
  //   path: process.env.VUE_APP_API,
  //   title: '工会费用银行付款申请'
  // },
  {
    path: process.env.VUE_APP_API,
    title: '后台'
  },
]